import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { FormProvider } from "./context/FormContext";

import Home from "./pages/Home";
import StepName from "./pages/StepName";
import StepDob from "./pages/StepDob";
import StepBirthTime from "./pages/StepBirthTime";
import StepLocation from "./pages/StepLocation";
import StepEmail from "./pages/StepEmail";
import StepFocus from "./pages/StepFocus";
import Questions from "./pages/Questions";
import Survey from "./pages/Survey";
import Success from "./pages/Success";
import ThankYou from "./pages/ThankYou";
import UpdateBirthTime from "./pages/UpdateBirthTime";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import { track } from "./utils/analytics";

// One page_view per route change, so drop-off between form steps is visible.
function PageViews() {
  const { pathname } = useLocation();
  useEffect(() => {
    track("page_view", { path: pathname });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <FormProvider>
      <PageViews />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/single-mums" element={<Home />} />
        <Route path="/name" element={<StepName />} />
        <Route path="/gender" element={<Navigate to="/dob" replace />} />
        <Route path="/dob" element={<StepDob />} />
        <Route path="/birth-time" element={<StepBirthTime />} />
        <Route path="/location" element={<StepLocation />} />
        <Route path="/email" element={<StepEmail />} />
        <Route path="/focus" element={<StepFocus />} />
        <Route path="/questions" element={<Questions />} />
        <Route path="/success" element={<Success />} />
        <Route path="/feedback" element={<Survey />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/order-questions" element={<ThankYou />} />
        <Route path="/update-birth-time" element={<UpdateBirthTime />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </FormProvider>
  );
}
